module.exports = __webpack_public_path__ + "img/step-anchor.586a4785.png";